import React from 'react'
import MaterialCommunityIcon from 'react-native-vector-icons/MaterialCommunityIcons'
import I18n from 'APP/I18n'
import DialogueTouchableOpacity from 'APP/Components/DialogueTouchableOpacity'
import Typography from 'APP/Converse/Typography'

import { Colors } from 'APP/Themes'
import styled from 'styled-components/native'

const StyledHeader = styled.View`
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  padding-horizontal: ${({ theme }) => theme.metrics.baseMargin * 1.5}px;
  padding-bottom: ${({ theme }) => theme.metrics.baseMargin}px;
`

const StyledHeaderTitle = styled(Typography).attrs(() => ({
  variant: 'h3',
}))`
  color: ${({ theme }) => theme.colors.text};
`

const StyledAddCtaText = styled(Typography).attrs(() => ({
  variant: 'buttonText',
}))`
  color: ${({ theme }) => theme.colors.text};
  padding-left: ${({ theme }) => theme.metrics.baseMargin / 3}px;
`

const StyledAddCta = styled(DialogueTouchableOpacity).attrs(() => ({
  variant: 'buttonText',
}))`
  flex-direction: row;
  padding: ${({ theme }) =>
    `${theme.metrics.baseMargin * 0.9}px 0 ${theme.metrics.baseMargin * 0.9}px 0`};
`

const Header = ({ onAddHabitPress }) => (
  <StyledHeader>
    <StyledHeaderTitle>{I18n.t('Habits.title')}</StyledHeaderTitle>
    <StyledAddCta
      testID="addCta"
      onPress={onAddHabitPress}
      accessibilityRole="button"
      accessibilityLabel={I18n.t('Habits.add')}
    >
      <MaterialCommunityIcon name="plus-thick" size={14} color={Colors.accent} />
      <StyledAddCtaText>{I18n.t('Habits.add')}</StyledAddCtaText>
    </StyledAddCta>
  </StyledHeader>
)

export default Header
